import { render, staticRenderFns } from "./call-disposition-creator.vue?vue&type=template&id=047ba564"
import script from "./call-disposition-creator.vue?vue&type=script&lang=js"
export * from "./call-disposition-creator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports